export class DetailBook {

    bookId: String;
    quantity: String;
    productId: String;
    sizeId: String;
    modalidadId: String;
}